import React from "react";
import styled from "styled-components";

const DocCompo = () => {
  return (
    <>
      <DocsMain>Documentation</DocsMain>
      <DocsPara>
        This documentation covers all the information needed to use Money
        Manager
      </DocsPara>
      <DocsContainer>
        <h3>1) Getting Started</h3>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum quis
          non dolore id nesciunt iure doloremque. Facere recusandae quasi harum
          minima nemo adipisci beatae dolores, tempore non eum quod minus?
        </p>
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/D0UnqGm_miA"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
      </DocsContainer>
      <Border></Border>
      <DocsContainer>
        <h3>2) How to create a project</h3>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum quis
          non dolore id nesciunt iure doloremque. Facere recusandae quasi harum
          minima nemo adipisci beatae dolores, tempore non eum quod minus beatae
          dolores, tempore non eum quod minus?
        </p>
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/D0UnqGm_miA"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
      </DocsContainer>
    </>
  );
};

export default DocCompo;

const DocsMain = styled.h3`
  font-weight: 500;
  font-size: 35px;
  font-family: "Source Serif Pro", serif;
  color: rgb(0, 104, 74);
`;

const DocsPara = styled.p`
  font-weight: 500;
  font-size: 17px;
  line-height: 25px;
  color: rgb(0, 30, 43);
`;

const DocsContainer = styled.div`
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  border: 1px solid #cfcfcf;
  margin-top: 15px;
  padding: 0px;
  border-radius: 8px;
  padding: 20px 20px;

  h3 {
    font-weight: 500;
    font-size: 22px;
    line-height: 25px;
    color: rgb(0, 30, 43);
    margin-top: 1rem;
  }
  p {
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: rgb(0, 104, 74);
    margin-top: 0.5rem;
  }
  iframe {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 900px;
    height: 400px;
    margin: 1.5rem auto;
  }

  @media only screen and (max-width: 991px) {
    padding: 18px 15px;
    iframe {
      width: 100%;
      height: 300px;
    }
  }
`;

const Border = styled.div`
  background-color: rgb(0, 104, 74);
  height: 1px;
  width: 100%;
  margin: 1.5rem 0rem;
`;
